import React from 'react';

function Chat() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <h1 className="text-3xl font-bold text-gray-700">🚧 Under Development 🚧</h1>
      <p className="mt-2 text-gray-500">We’re working hard to bring this feature to you soon!</p>
    </div>
  );
}

export default Chat;